module.exports = __webpack_public_path__ + "static/media/alan.995a9ad5.png";